/** 与后端 PermissionTypeEnum 对齐：1=菜单 2=按钮 3=分组（按钮/API 不进侧栏） */
export const MENU_TYPE_MENU = 1;
export const MENU_TYPE_BUTTON = 2;
export const MENU_TYPE_GROUP = 3;

/** 与后端 PermissionHiddenEnum 对齐：1=显示 2=隐藏 */
export const MENU_VISIBLE = 1;
export const MENU_HIDDEN = 2;

/** 动态业务页统一挂在这一条 Layout 下，避免每个一级菜单各挂一份导致 keep-alive 被拆掉 */
export const APP_LAYOUT_ROUTE_NAME = "AppLayout";
/** 与静态 `/` → /login 并存：本路由靠 children 匹配 /dashboard、/product/goods 等 */
export const APP_LAYOUT_ROUTE_PATH = "/";

/** 登录落地：客户端为工作台首页；管理端 / 后台仍作桥接，不进侧栏 */
export const APP_DASHBOARD_PATH = "/dashboard";
